import { Component, inject } from '@angular/core';
import { ProductCategoryService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ProductCategoryCreateDto,
  ProductCategoryDto,
  ProductCategoryExcelDownloadDto,
  ProductCategoryUpdateDto,
} from '../proxy/general/dtos/product-category';
import { PRODUCTCATEGORY_CONFIG, PRODUCTCATEGORY_FIELDS } from './product-category.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-product-category',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ProductCategoryService, ConfirmationService],
  templateUrl: './product-category.html',
  styleUrl: './product-category.scss',
})
export class ProductCategory extends BaseCrudComponent<
  ProductCategoryDto,
  ProductCategoryCreateDto,
  ProductCategoryUpdateDto,
  ProductCategoryExcelDownloadDto
> {
  service = inject(ProductCategoryService);
  config = PRODUCTCATEGORY_CONFIG;
  fields = PRODUCTCATEGORY_FIELDS;

  protected prepareUpdateDto(data: any, selected: ProductCategoryDto): ProductCategoryUpdateDto {
    return {
      name: data.name,
      code: data.code,
      isPulpable: data.isPulpable,
      isReturnable: data.isReturnable,
      isByProduct: data.isByProduct,
      mustBeSentToSap: data.mustBeSentToSap,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ProductCategory';
  }
}
